import { isApiError } from '@finmin/api-client';
import { toast } from '@finmin/ui';
import { getChannelPartnerDocumentDownload } from '@/api/channel-partners';

/**
 * Open a CP attachment or the published agreement. The endpoint returns a
 * short-lived presigned URL (JSON), not the file bytes, so the URL itself is
 * safe to open. The tab is opened synchronously inside the click so popup
 * blockers allow it, then pointed at the URL once the backend responds —
 * call this directly from a click handler.
 */
export async function openChannelPartnerDocument(documentId: string): Promise<void> {
  const win = window.open('', '_blank');
  if (win) win.opener = null;
  try {
    const { download_url } = await getChannelPartnerDocumentDownload(documentId);
    if (win) win.location.href = download_url;
    else window.open(download_url, '_blank', 'noopener');
  } catch (err) {
    win?.close();
    toast.error('Could not open document', isApiError(err) ? err.message : 'Please try again.');
  }
}
